var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFilter = function SvgFilter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.3008C10.1642 11.3008 10.5 11.6366 10.5 12.0508C10.5 12.465 10.1642 12.8008 9.75 12.8008H6.25C5.83585 12.8007 5.5 12.465 5.5 12.0508C5.50003 11.6366 5.83586 11.3008 6.25 11.3008H9.75ZM11.5 7.30078C11.9142 7.30078 12.25 7.63657 12.25 8.05078C12.25 8.46502 11.9142 8.80078 11.5 8.80078H4.5C4.08579 8.80078 3.75 8.46502 3.75 8.05078C3.75003 7.63657 4.08581 7.30078 4.5 7.30078H11.5ZM13.251 3.30078C13.665 3.30101 14.001 3.6367 14.001 4.05078C14.001 4.46488 13.665 4.80056 13.251 4.80078H2.75C2.33579 4.80076 2 4.46501 2 4.05078C2.00003 3.63658 2.3358 3.3008 2.75 3.30078H13.251Z",
    fill: "white"
  })));
};
export default SvgFilter;